/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AfterViewInit, Component, HostListener, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { OverlayPanel } from 'primeng/overlaypanel';
import { MenuItem } from 'primeng/api/menuitem';
import { TabSearchParameter } from '../../../core/model/tab-search-parameter.model';
import { ThpHistory } from '../../../core/model/thp-history-model';
import { LmsMenuService } from '../../../core/services/lms-menu.service';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';
import { AppUtilityService } from './../../../core/services/app-utility.service';


@Component({
  selector: 'lms-thp-history-data',
  templateUrl: './thp-history-data.component.html',
  styleUrls: ['./thp-history-data.component.scss']
})
export class ThpHistoryDataComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() history: Array<ThpHistory>;
  @Input() scrollHeight: number;
  @Input() upperHeight: number;

  historyData: Map<string, Array<ThpHistory>>;
  showingFrom: number;
  showingTo: number;
  totalRecords: number;
  isHistorySorted = false;
  rowsPerPage: number;
  historyToShow: Array<ThpHistory>;
  firstIndex: number;
  lastIndex: number;
  trainLinks: Array<MenuItem>;
  overlayLinks: Array<MenuItem>;
  overlayPanel: OverlayPanel;
  panelVisible = false;
  contextType: string;
  contextSearchText: string;
  currentContextLoco: ThpHistory;
  contextPanel: any;

  @ViewChild('viewPortPaging') viewPageDirective;

  /**
   * Creates an instance of ThpHistoryDataComponent.
   * @param {Router} router
   * @memberOf ThpHistoryDataComponent
   */
  constructor(private router: Router, private appUtilityService: AppUtilityService,
    private lmsMenuService: LmsMenuService, private lmsRendererService: LmsRendererService) {
    this.trainLinks = this.lmsMenuService.getMenuItem('Train').subTypes;
    this.historyData = new Map();
    this.lmsRendererService.historyOverlayObs.subscribe((overlay) => {
      if (overlay && overlay === 'COMMHIS') {
        this.checkForOverlayPanelVisibility();
      }
    });
  }

  ngOnInit() { }

  /**
   * this is the lifecycle method of this component
   * this method is used to calculate the total number
   * of records for thp history table
   * @memberOf ThpHistoryDataComponent
   */
  ngOnChanges() {
    if (this.history && this.history.length > 0) {
      this.rowsPerPage = this.appUtilityService.getRowPerPageCount(40, this.upperHeight);
      // this.rowsPerPage = 10;
      this.historyToShow = this.history.slice(0, (this.history.length > this.rowsPerPage ? this.rowsPerPage : this.history.length));
      this.firstIndex = this.history.indexOf(this.historyToShow[0]);
      this.lastIndex = this.history.indexOf(this.historyToShow[this.historyToShow.length - 1]);
      this.totalRecords = this.history.length;
      setTimeout(() => {
        this.checkWhetherHeaderAdjusted();
        this.viewPageDirective.updateScreenSizeSetting();
      }, 30);
    }
  }


  /**
   * this is the lifecycle method of this component
   * this mehtod is used to bind a scroll event to table's
   * scrollable area.
   * @memberOf ThpHistoryDataComponent
   */
  ngAfterViewInit() {
    this.checkWhetherHeaderAdjusted();
  }

  getPagingdata($event) {
    this.showingFrom = $event.paging.start;
    this.showingTo = $event.paging.end;
    this.checkForOverlayPanelVisibility();
  }

  private checkWhetherHeaderAdjusted() {
    const scrollableBody = document.getElementById('thpHistoryTable');
    const tableHeader = document.getElementById('thpHistoryHeader');
    if (tableHeader && scrollableBody) {
      const items = scrollableBody.querySelectorAll('.thpHistory-tbl-data');
      const header = document.getElementById('thpHistoryHeading');
      const pagination = document.getElementById('thpHistoryPagination');
      if (Math.ceil((scrollableBody.clientHeight - 25) / 40) < items.length) {
        const scrollWidth = scrollableBody.offsetWidth - scrollableBody.clientWidth;
        tableHeader.setAttribute('style', `margin-right: ${scrollWidth}px !important`);
        header.setAttribute('style', `width: calc(100% - ${scrollWidth}px);`);
        pagination.setAttribute('style', `width: calc(100% - ${scrollWidth}px);`);
      } else {
        tableHeader.removeAttribute('style');
        header.removeAttribute('style');
        pagination.removeAttribute('style');
      }
    }
  }

  /**
   * this method is used to calculate the records numbers that are currenlty visible
   * in table view area.
   * @memberOf ThpHistoryDataComponent
   */
  public scrollEventOccured() {
    const scrollableBody = document.getElementById('thpHistoryTable');
    if (scrollableBody) {
      const clientHeight = scrollableBody.clientHeight;
      const scrollHeight = scrollableBody.scrollHeight;
      const scrollTop = scrollableBody.scrollTop;
      const diff = (clientHeight + scrollTop) - scrollHeight;
      if (diff <= 2 && diff >= -2) {
        this.loadNextSetofData();
      }
      // if (this.viewPageDirective) {
      //   this.viewPageDirective.updateScreenSizeSetting();
      // }
    }
  }

  private loadNextSetofData() {
    this.historyToShow = this.history.slice(0, (this.history.length > (this.lastIndex + this.rowsPerPage) ? (this.lastIndex + this.rowsPerPage) : this.history.length));
    this.firstIndex = this.history.indexOf(this.historyToShow[0]);
    this.lastIndex = this.history.indexOf(this.historyToShow[this.historyToShow.length - 1]);
  }

  setOverlayLinks() {
    this.checkForOverlayPanelVisibility();
    this.overlayLinks = this.trainLinks;
  }

  public locomotiveOverlayPosition(event, panel: OverlayPanel, trainId: string, index: string, trainType: string) {
    // this.overlayPanel ;
    if (!panel.overlayVisible && this.panelVisible === true) {
      this.panelVisible = false;
    }
    if (this.panelVisible) {
      this.overlayPanel.hide();
      this.panelVisible = false;
      event.stopPropagation();
      return;
    }
    panel.show(event);
    const overlayPanel = document.getElementById('thpHistoryOverlayId').getElementsByClassName('p-overlaypanel');
    let element;
    element = document.getElementById(trainType + index + trainId);
    this.contextType = 'Train';
    this.contextSearchText = trainId;
    const rect = element.getBoundingClientRect();
    const scrollHeight = window.pageYOffset;
    const windowHeight = window.innerHeight;
    let overlayHeight = 0;
    if (this.overlayLinks && this.overlayLinks.length > 0) {
      overlayHeight = this.overlayLinks.length * 30;
    } else {
      panel.hide();
      return;
    }
    let top;
    if ((windowHeight - rect.top - rect.height) > overlayHeight) {
      top = rect.top + rect.height + scrollHeight + 'px';
    } else {
      top = (rect.top - overlayHeight) + scrollHeight + 'px';
    }
    const left = rect.left + 'px';
    const width = rect.width + 'px';
    let style = `display: block; z-index: 1001; visibility: visible;
            opacity: 1.032; top: <<top>>; left: <<left>>; width: <<width>>;`;
    style = style.replace('<<top>>', top);
    style = style.replace('<<left>>', left);
    style = style.replace('<<width>>', width);
    overlayPanel[0].setAttribute('style', style);
    event.stopPropagation();
    this.panelVisible = true;
    this.currentContextLoco = null; //@@7749 [WAS] this.currentContextLoco = alert;
    this.overlayPanel = panel;
    this.lmsRendererService.updateOverlayVisibility('THPHIS');
  }

  public hideLocoOverlayPanel(event, panel: OverlayPanel) {
    this.checkForOverlayPanelVisibility();
    if (this.panelVisible) {
      panel.hide();
      this.panelVisible = false;
      panel = null;
      this.currentContextLoco = null;
      return;
    }
  }

  checkForOverlayPanelVisibility() {
    if (this.overlayPanel) {
      this.overlayPanel.hide();
      this.currentContextLoco = null;
      this.overlayPanel = null;
      this.contextType = null;
      this.contextSearchText = null;
      this.overlayLinks = null;
    }
  }

  @HostListener('document:click') hideAddTabPanel(event) {
    this.checkForOverlayPanelVisibility();
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  /**
   * this menthod is used to route the user to clicked screen with specified values
   * value can be a temrinal mnemonic/train id/ locomotive id
   * @param {string} subType
   * @param {string} type
   * @param {string} searchText
   * @memberOf ThpHistoryDataComponent
   */
  public routeToPage(subType: string, type: string, searchText: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: searchText });
    this.appUtilityService.navigateByUrl(type, subType, tabSearchParameter.searchText, true);
  }

}
